export default __webpack_public_path__ + "static/media/new-registrars.902107c9.webp";